module.exports = "/_next/static/images/tree-line-12e295406b9b3baaa1580054afac86aa.svg";